module.exports = __webpack_public_path__ + "media/images/main/clouds-d14cf5680eb242d251a50ab66040df2d.png";